// extracted by mini-css-extract-plugin
export default {"fs":"_46dc11c6b1 _4fef32302e"};